import { Component, OnInit } from '@angular/core';
import { SedsModalAbstractComponent } from 'experian-design-system';
@Component({
    selector: 'pl-error-loading-modal',
    templateUrl: './error-loading-modal.component.html',
    styleUrls: ['./error-loading-modal.component.scss'],
    standalone: false
})
export class ErrorLoadingModalComponent  extends SedsModalAbstractComponent implements OnInit {
    public title: string = 'Não foi possível carregar as informações';

    constructor() {
        super();
    }

    override ngOnInit() {
      super.ngOnInit();
      this.title = this.data?.title;
   }
}